import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import Logo from './img/Logo.png';

class AdminMenu extends Component {
  constructor () {
    super();
    this.state = {
    };
  }
  setMenu = (page) => {
    this.props.setMenuPage(page);
  };
  render() {
    return (
      <div
        className="admin-menu"
      >
        <div className="admin-menu-img">
          <img src={Logo} alt="Logo" />
        </div>
        {/* <button
          className={`admin-menu-button ${this.props.pageControl.menu === 'clients' && '-active'}`}
          onClick={() => this.setMenu('clients')}
        >CLIENTS
        </button> */}
        <button
          className={`admin-menu-button ${this.props.pageControl.menu === 'cars' && '-active'}`}
          onClick={() => this.setMenu('cars')}
        >CARS
        </button>
        {/* <button
          className={`admin-menu-button ${this.props.pageControl.menu === 'dealers' && '-active'}`}
          onClick={() => this.setMenu('dealers')}
        >DEALERS
        </button>
        <button
          className={`admin-menu-button ${this.props.pageControl.menu === 'finances' && '-active'}`}
          onClick={() => this.setMenu('finances')}
        >FINANCES
        </button>
        <button
    className={`admin-menu-button ${this.props.pageControl.menu === 'integrations' && '-active'}`}
          onClick={() => this.setMenu('integrations')}
        >INTEGRATIONS
        </button> */}
        <button
          className={`admin-menu-button ${this.props.pageControl.menu === 'settings' && '-active'}`}
          onClick={() => this.setMenu('settings')}
        >SETTINGS
        </button>
        <button
          className="admin-menu-button"
          onClick={this.props.logoutFunction}
        >LOGOUT
        </button>
      </div>
    );
  }
}

AdminMenu.propTypes = {
  logoutFunction: PropTypes.func.isRequired,
  setMenuPage: PropTypes.func.isRequired,
  pageControl: PropTypes.instanceOf(Object).isRequired
};

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/adminMenu/index.js